import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Platform } from 'react-native';
import { Dropdown } from 'fitbeat.react-native-components';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
const isMobileWeb = Platform.OS === "web" && window.innerWidth <= 550;
const isWeb = Platform.OS === "web";
const isSmallMobile = window.innerWidth <= 350;
export const TrackingDateSelector = reduxForm({ form: 'MonthYearSelector' })(
  ({monthAndYearRange, selectedMonthAndYear, getTrackingStats}) => {
    const menuListStyle = isMobileWeb ? {
      width: '90vw',
      right: 0,
      backgroundColor: Theme.GREY_DARK
    } : isWeb ? {backgroundColor: Theme.GREY_DARK, left: 0, width: '50vw'} : { left: 0, width: '50vw'}
    return (
      <Field
        webAbsolute
        useTransparentDarkTheme={isWeb ? true : false}
        name="monthYear"
        showLabel={false}
        placeholder="Select a period"
        valueKey="value"
        displayKey="displayName"
        defaultValue={selectedMonthAndYear.value}
        options={monthAndYearRange}
        component={Dropdown}
        controlStyle={{alignSelf: 'flex-end', backgroundColor: 'transparent'}}
        controlTextStyle={{...Theme.textStyle.bodyCopyMed, border: 0}}
        optionsStyle={{marginTop: defaultScale(10), backgroundColor: 'transparent'}}
        isRequired={false}
        onSelect={getTrackingStats}
        hideIndicatorSeparator={true}
        useDarkTheme={isWeb ? false : true}
        useFullScreenWidth={true}
        adjustFrameOptions={{ left: defaultScale(15) }}
        menuListStyle={menuListStyle}
        mainDropdownContainerStyle={{width: '100%', flex: 1, border: 0, marginTop: defaultScale(-3),  marginRight: defaultScale(-9), backgroundColor: 'transparent'}}
        menuPlacement="auto"
      />);

  }
);

